import { Instagram, Youtube, BookOpen } from "lucide-react";
import heroBg from "@/assets/hero-bg.jpg";

const AboutSection = () => (
  <section id="sobre" className="py-16 sm:py-24 bg-card/50">
    <div className="container mx-auto px-5 sm:px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div>
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold mb-6">
              Leonardo <span className="text-gradient-green">Hallal</span>
            </h2>
            <p className="text-sm sm:text-lg text-muted-foreground mb-6 font-light leading-relaxed">
              Executivo de moda e criador da teoria das 12 Personas de Estilo. <br />
              Leonardo já analisou, em suas redes sociais, o estilo de mais de 5.000 pessoas. <br />
              Ao longo dos últimos 30 anos, ajudou a criar os pilares de identidade da moda brasileira.
              <br />
              Desenvolveu estampas, criou cartelas de cores e distribuiu tecidos para as as marcas mais importantes do país.
              <br />
              Hoje também é Diretor de Produtos da maior distribuidora têxtil da América Latina.
            </p>

            <div className="flex flex-wrap items-center gap-4 sm:gap-6">
              <a href="https://hallal.com.br/" target="_blank" rel="noopener noreferrer" aria-label="Site oficial de Leonardo Hallal" className="p-3 bg-secondary hover:bg-primary hover:text-primary-foreground rounded-full transition-smooth">
                <BookOpen className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/leonardo.hallal/" target="_blank" rel="noopener noreferrer" aria-label="Instagram de Leonardo Hallal" className="p-3 bg-secondary hover:bg-primary hover:text-primary-foreground rounded-full transition-smooth">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://www.youtube.com/@leonardo.hallal" target="_blank" rel="noopener noreferrer" aria-label="YouTube de Leonardo Hallal" className="p-3 bg-secondary hover:bg-primary hover:text-primary-foreground rounded-full transition-smooth">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div className="relative">
            <div className="aspect-[4/5] rounded-3xl overflow-hidden border border-border/30 relative">
              <img
                src={heroBg}
                alt="Leonardo Hallal"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
              <div className="absolute inset-0 bg-primary/15 mix-blend-overlay" />
              <div className="absolute bottom-0 left-0 right-0 p-5 sm:p-8 flex items-end justify-center">
                <p className="text-base sm:text-xl md:text-2xl font-display italic text-white text-center leading-relaxed">
                  "Você atrai o que a sua imagem transmite <br className="hidden sm:block" /> Então transmita as mensagens certas!"
                </p>
              </div>
            </div>
            <div className="absolute -bottom-4 -right-2 sm:-right-4 w-16 h-16 sm:w-24 sm:h-24 bg-primary rounded-2xl flex items-center justify-center shadow-glow">
              <BookOpen className="w-7 h-7 sm:w-10 sm:h-10 text-primary-foreground" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AboutSection;
